import { DefinedRange } from 'materialui-daterange-picker'
import {
  addDays,
  addMonths,
  startOfDay,
  endOfDay,
  format,
  isEqual,
} from 'date-fns'
import { DateRange as DatePickerDateRange } from 'materialui-daterange-picker'

const DATE_FORMAT = 'LLL d, Y'

export interface DateRange extends DefinedRange {
  id: string
}

export const getDefaultRanges = (date: Date): DateRange[] => [
  {
    id: 'all',
    label: 'all',
    startDate: undefined,
    endDate: undefined,
  },
  {
    id: 'today',
    label: 'today',
    startDate: startOfDay(date),
    endDate: endOfDay(date),
  },
  {
    id: 'yesterday',
    label: 'yesterday',
    startDate: addDays(startOfDay(date), -1),
    endDate: addDays(endOfDay(date), -1),
  },
  {
    id: 'last7Days',
    label: 'last7Days',
    startDate: addDays(startOfDay(date), -7),
    endDate: endOfDay(date),
  },
  {
    id: 'last30Days',
    label: 'last30Days',
    startDate: addDays(startOfDay(date), -30),
    endDate: endOfDay(date),
  },
  {
    id: 'last12Months',
    label: 'last12Months',
    startDate: addMonths(startOfDay(date), -12),
    endDate: endOfDay(date),
  },
]

export const getCustomRange = (range: DatePickerDateRange): DateRange => {
  if (!range) return null

  const { startDate, endDate } = range
  const label = `${format(startDate, DATE_FORMAT)} - ${format(
    endDate,
    DATE_FORMAT
  )}`

  return {
    id: 'custom',
    label,
    startDate,
    endDate,
  }
}

export const getSelectedDateRange = (
  range: DatePickerDateRange,
  ranges: DateRange[]
): DateRange => {
  if (!range || (!range.startDate && !range.endDate)) return ranges[0]

  const { startDate, endDate } = range
  const found: DateRange = ranges.find(
    (dr) => isEqual(dr.startDate, startDate) && isEqual(dr.endDate, endDate)
  )

  return found ?? getCustomRange(range)
}
